import reducer from "./reducers";

import * as wizardOperations from "./operations";

export { wizardOperations };

export default reducer;
